<style lang="scss">
// Base
$font-size: 14px;
$spacing: 15px;
$cellHeight: 28px;
$markerHeight: 16px;

// Colors
$markerColor: #10b981;
$textColor: #464957;
$parentItemColor: #1d313a;
$childItemColor: $textColor;

// Fonts
$parentItemFontSize: 13px;
$childItemFontSize: 12px;

/// Slightly lighten a color
/// @access public
/// @param {Color} $color - color to tint
/// @param {Number} $percentage - percentage of `$color` in returned color
/// @return {Color}
/// 
@function lighten($color, $percentage) {
	@return mix(white, $color, $percentage);
}

/// Slightly darken a color
/// @access public
/// @param {Color} $color - color to shade
/// @param {Number} $percentage - percentage of `$color` in returned color
/// @return {Color}
/// 
@function darken($color, $percentage) {
	@return mix(black, $color, $percentage);
}

/*
| ------------------
| KEY MOMENTS DROPDOWN
| -------------------
| Dropdown to navigate to specific events
*/
.optform-gantt-wrapper .key-moments-dropdown {
	display: flex;
	align-items: center;
	gap: 10px;
	margin-bottom: 15px;
	padding: 10px;
	background: #f8f9fa;
	border-radius: 8px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

	label {
		font-size: 14px;
		font-weight: 500;
		color: #212121;
		font-family: SpaceGrotesk, sans-serif;
	}

	select {
		padding: 8px 12px;
		border: 1px solid #e9ecef;
		border-radius: 6px;
		background: #fff;
		font-size: 14px;
		color: #212121;
		font-family: SpaceGrotesk, sans-serif;
		cursor: pointer;
		min-width: 200px;

		&:focus {
			outline: none;
			border-color: #10b981;
			box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.1);
		}
	}
}

/*
| ------------------
| GANTT TOBAR
| -------------------
| Contains information about the gantt chart such as
| the title and the date fields that are shown
*/
.optform-gantt-wrapper .gantt-topbar {
	display: flex;
	color: $textColor;
	margin-bottom: 10px;
	.gantt-actions {
		display: flex;
		margin: auto 0 auto auto;


		.prev,
		.next {
			width: 32px;
			height: 32px;
			display: flex;
			align-items: center;
			justify-content: center;
			background: #ffffff;
			border: none;
			border-radius: 6px;
			margin-left: 10px;
			margin-top: 5px;
			cursor: pointer;
			transition: background-color 0.2s, transform 0.1s;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
			&:hover {
				background: #e9ecef;
				transform: scale(1.05);
			}
			svg {
				width: 18px;
				height: 18px;
				color: #212121;
			}
		}
		.prev-double,
		.next-double {
			width: 32px;
			height: 32px;
			display: flex;
			align-items: center;
			justify-content: center;
			background: #ffffff;
			border: none;
			border-radius: 6px;
			margin-left: 5px;
			margin-right: 5px;
			margin-top: 0px;
			cursor: pointer;
			transition: background-color 0.2s, transform 0.1s;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
			&:hover {
				background: #e9ecef;
				transform: scale(1.05);
			}
			svg {
				width: 15px;
				height: 15px;
				color: #212121;
			}
		}		
		.flatpickr-input {
			padding: 8px 8px;
			margin-left: 10px;
			width: 100px;
			text-align: center;
			border: none;
			border-radius: 8px;
			background-color: #f8f9fa;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
			font-family: SpaceGrotesk, sans-serif;
			font-size: 14px;
			color: #212121;
		}
		.time-navigation {
			display: flex;
			align-items: center;
			gap: 0;
			margin-left: 10px;
			margin-top: -2px;
			padding: 6px 10px;
			background-color: #f8f9fa;
			border-radius: 8px;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
			.prev,
			.next {
				width: 32px;
				height: 32px;
				display: flex;
				align-items: center;
				justify-content: center;
				background: #ffffff;
				border: none;
				border-radius: 6px;
				margin: 0;
				cursor: pointer;
				transition: background-color 0.2s, transform 0.1s;
				&:hover {
					background: #e9ecef;
					transform: scale(1.05);
				}
				svg {
					width: 18px;
					height: 18px;
					color: #212121;
				}
			}
			.time-display {
				padding: 0 12px;
				background: transparent;
				border: none;
				font-size: 12px;
				font-weight: 500;
				color: #212121;
				font-family: SpaceGrotesk, sans-serif;
				min-width: 180px;
				text-align: center;
			}
		}
	}
.granularity-controls {
	span {
		margin: 0 8px;
		font-size: 12px;
	}
	display: flex;
	align-items: center;
	margin-left: 10px;
	button {
		width: 24px;
		height: 24px;
		// border: 1px solid #efefef;
		// background: #fff;
		cursor: pointer;
		&:disabled {
			opacity: 0.5;
			cursor: not-allowed;
		}
	}
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 6px 10px;
	margin-top: -2px;
	background-color: #f8f9fa;
	border-radius: 8px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	font-family: SpaceGrotesk, sans-serif;
}

.control-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.1s;
}

.control-button:hover:not(:disabled) {
  background-color: #e9ecef;
  transform: scale(1.05);
}

.control-button:disabled {
  background-color: #f1f3f5;
  cursor: not-allowed;
  opacity: 0.5;
}

.control-button svg {
  width: 18px;
  height: 18px;
  color: #212121;
}

.granularity-text {
  font-size: 14px;
  font-weight: 500;
  color: #212121;
  text-transform: capitalize;
  min-width: 80px;
  text-align: center;
}
}

/*
| ------------------
| GANTT CHART
| -------------------
| Contains the styling of the actual gantt chart
| Gant charts will consist of a header a body and a footer
*/
.optform-gantt-wrapper .gantt-chart {
	width: 100%;
	background: #fff;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	font-size: $font-size;
	position: relative;
	color: $textColor;
	border-collapse: separate;
	border-spacing: 0;

	/* Reset table borders only, preserve other elements */
	table, td, th, tr {
		border: none !important;
		border-collapse: collapse !important;
	}
	
	/* Fix background for graph section - body only */
	.gantt-body .graph-section {
		background: #f4f4f4 !important;
	}
	
	/* Limit cell width to prevent overlapping */
	.table-cell {
		max-width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		box-sizing: border-box;
		border: none !important;
		*, *::before, *::after {
			border: none !important;
			box-shadow: none !important;
		}
	}
	/*
    | ------------------
    | GANTT HEADER
    | -------------------
    | Contains the styling of the generated
    | header fields of the Gantt chart
    */
	.gantt-header {
		display: flex;
		height: 40px;
		border-bottom: 1px solid #f4f4f4;

		// Gantt table section
		.table-section {
			height: 100%;
			display: flex;
			flex-wrap: wrap;
			font-size: $font-size;
			width: 30%;
			background: #fff;
			z-index: 0;

			.table-cell {
				&.sortable {
					cursor: pointer;
					&:hover {
						font-weight: 600;
					}
				}
			}
		}

		// Gantt chart section
		.graph-section {
			height: 100%;
			display: flex;
			overflow: visible;
			background: #fff !important;
			.table-cell {
				text-align: center;
				padding: 0;
				.day {
					font-size: 12px;
					margin-right: 5px;
				}
				.month {
					font-size: 10px;
				}
				.tooltip {
					overflow: visible;
					// overflow: visible;
				}
			}
		}

		// Table cell
		.table-cell {
			line-height: 40px;
			padding: 0 10px;
			user-select: none;
			&.hidden-date {
				content: '';
			}
		}
	}

	/*
    | ------------------
    | GANTT BODY
    | -------------------
    | Contains the styling of the generated
    | body of the Gantt chart.
    | This will be devided in rows and each row can have cells.
    */
	.gantt-body {
		display: flex;
		flex-wrap: wrap;
		position: relative;

		.gantt-row {
			display: flex;

			.table-section {
				display: flex;
				height: $cellHeight;
				line-height: $cellHeight;
				width: 100%;

				.toggle {
					display: flex;
					cursor: pointer;
					&:hover {
						background: #f4f4f4;
					}
					.open,
					.close {
						border-left: 1px solid $textColor;
						border-bottom: 1px solid $textColor;
						width: 5px;
						height: 5px;
						margin: auto;
					}
					.open {
						transform: rotate(-45deg);
					}
					.close {
						transform: rotate(135deg);
					}
				}

				.table-group {
					display: flex;
				}

				.table-cell {
					&:hover {
						background: #f4f4f4;
					}
				}
			}

			.graph-section {
				background: #f4f4f4;
				// overflow: hidden;
				.graph-row {
					display: flex;
					position: relative;
					height: 100%;
				}
			}

			&.parent {
				.table-cell {
					input {
						font-size: $parentItemFontSize;
						color: $parentItemColor;
						font-weight: 700;
						border: none;
					}
				}
			}

			&.child {
				.table-group {
					display: flex;
					position: relative;
					&:before {
						content: '';
						height: $cellHeight / 2;
						position: absolute;
						width: 1px;
						background: rgba($childItemColor, 0.3);
						left: 12px;
						top: $cellHeight / 4;
					}
				}
			}

			.table-cell {
				height: 100%;
				flex: none;
				transition: background 0.3s;
				display: flex;
				&.weekend {
					background: #e8e8e8;
				}
				&.toggler {
					width: 20px;
				}
				&.disabled {
					pointer-events: none;
					background: #f4f4f4;
				}
				&.non-editable {
					pointer-events: none;
					user-select: none;
					input {
						pointer-events: none;
						user-select: none;
						cursor: default;
					}
				}
				&.flash {
					background: rgba($markerColor, 0.1);
				}
				input {
					font-size: $childItemFontSize;
					color: $childItemColor;
					&.cell.number {
						padding-right: 0;
					}
				}
			}

			.marker {
				width: 100%;
				cursor: pointer;
				position: absolute;
				&:hover .tooltip {
					opacity: 1;
					visibility: visible;
				}

				&.parent {
					height: $markerHeight / 3;
					margin-top: ($cellHeight - ($markerHeight / 3)) / 1.5;
					background: darken($markerColor, 40%);
					border-radius: 15px;
					&:after,
					&:before {
						transform-origin: bottom;
						position: absolute;
						content: '';
						bottom: 0;
					}
					&:after {
						left: -2px;
						transform: rotate(-50deg);
						border-color: transparent transparent darken($markerColor, 40%) transparent;
						border-style: solid;
						border-width: 0px 5px 5px 5px;
						height: 0px;
						width: 0px;
					}
					&:before {
						right: -2px;
						transform: rotate(50deg);
						border-color: transparent transparent darken($markerColor, 40%) transparent;
						border-style: solid;
						border-width: 0px 5px 5px 5px;
						height: 0px;
						width: 0px;
					}
				}
				&:not(.parent) {
					height: $markerHeight;
					background: $markerColor;
					border-radius: 15px;
					margin-top: ($cellHeight - $markerHeight) / 2;
					.marker-proportion {
						background: lighten($markerColor, 20%);
					}

					&:hover {
						background: lighten($markerColor, 10%);
					}
				}

				.marker-user,
				.marker-proportion {
					pointer-events: none;
				}

				.marker-user {
					position: absolute;
					left: 1px;
					top: 1px;
					width: $markerHeight - 2px;
					height: $markerHeight - 2px;
					z-index: 1;
					display: flex;
					img {
						width: 100%;
						height: 100%;
						border-radius: 50%;
					}
				}

				.marker-proportion {
					height: 100%;
					display: block;
					border-radius: 15px 0 0 15px;
					position: absolute;
					left: 0;
					top: 0;

					&.completed {
						border-radius: 15px;
					}
				}

				&.selected {
					pointer-events: none;
				}

				.tooltip {
					position: absolute;
					top: -80px;
					left: 50%;
					transform: translateX(-50%);
					background: rgba(0, 0, 0, 0.9);
					color: white;
					padding: 8px 12px;
					border-radius: 6px;
					font-size: 12px;
					white-space: nowrap;
					z-index: 1000;
					opacity: 0;
					visibility: hidden;
					transition: opacity 0.2s, visibility 0.2s;
					pointer-events: none;
					&:after {
						content: '';
						position: absolute;
						top: 100%;
						left: 50%;
						transform: translateX(-50%);
						border: 5px solid transparent;
						border-top-color: rgba(0, 0, 0, 0.9);
					}
				}
			}
		}

        /*
        | ------------------
        | GANTT GRAPH PANEL
        | -------------------
        | Contains the graph content
        | This is a scrollable panel of all charts
        */
        .gantt-graph-panel{
            background: #f4f4f4;
            position: relative;
            .gantt-row{
                height: $cellHeight;
            }
        }
	}

	.gantt-graph,
	.graph-row {
		justify-content: flex-end;
		.table-cell {
			flex: none;
		}
	}
}
</style>

<template>
    <div class="optform-gantt-wrapper">
        <!-- Key Moments Dropdown -->
        <div class="key-moments-dropdown" v-if="keyMoments.length > 0">
            <label for="key-moments">Key Moments:</label>
            <select id="key-moments" @change="navigateToMoment($event.target.value)">
                <option value="">Select a moment...</option>
                <option v-for="moment in keyMoments" :key="moment.id" :value="moment.start_date">
                    {{ moment.id }} - {{ moment.summary }}
                </option>
            </select>
        </div>

        <!-- Gant Topbar -->
        <div class="gantt-topbar">
            <div class="mt-3 gantt-title" v-html="title"></div>
            <div class="gantt-actions">
                <div class="prev" @click="prev">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="15 18 9 12 15 6" />
                    </svg>
                </div>
                <flat-pickr ref="input" v-model="localStartDate"></flat-pickr>
                <flat-pickr ref="input" v-model="localEndDate"></flat-pickr>
                <div class="next" @click="next">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right">
                        <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                </div>
                <div class="time-navigation" v-if="['hours', 'minutes', 'seconds', 'milliseconds'].includes(granularity)">
                    <div class="prev-double" @click="prevDoubleTime">
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
							<path stroke-linecap="round" stroke-linejoin="round" d="m18.75 4.5-7.5 7.5 7.5 7.5m-6-15L5.25 12l7.5 7.5" />
						</svg>
                    </div>					
                    <div class="prev" @click="prevTime">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="15 18 9 12 15 6" />
                        </svg>
                    </div>
                    <div class="time-display">
                        {{ timeStartDate | moment('YYYY-MM-DD HH:mm:ss.SSS') }}
                    </div>
                    <div class="next" @click="nextTime">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="9 18 15 12 9 6" />
                        </svg>
                    </div>
                    <div class="next-double" @click="nextDoubleTime">
						<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
							<path stroke-linecap="round" stroke-linejoin="round" d="m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5" />
						</svg>
                    </div>						
                </div>
				<div class="granularity-controls">
					<button @click="drillUp" :disabled="granularity === 'days'" class="control-button" aria-label="Zoom out" title="Zoom out to a coarser granularity">
					<!-- <svg width="24" height="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(180deg);">
						<path
						d="M11.25 13.75a.75.75 0 0 1 .072.976l-.072.084-1.971 1.97a.75.75 0 0 1-.977.073l-.084-.073-1.97-1.97a.75.75 0 0 1 .977-1.133l.085.072.69.691V7.75a.75.75 0 0 1 .647-.743l.102-.007a.75.75 0 0 1 .743.648l.007.102v6.69l.69-.69a.75.75 0 0 1 .976-.072l.085.072ZM1.999 12c0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.524-4.477-10-10-10s-10 4.476-10 10Zm15.666 1.677.085.072a.75.75 0 0 1 .072.977l-.072.084-1.971 1.97a.75.75 0 0 1-.977.073l-.084-.073-1.97-1.97a.75.75 0 0 1 .978-1.133l.084.072.69.691V7.75a.75.75 0 0 1 .647-.743l.102-.007a.75.75 0 0 1 .743.648l.007.102v6.69l.69-.69a.75.75 0 0 1 .976-.072Z"
						fill="currentColor"
						/>
					</svg> -->
					<svg width="24" height="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(180deg);">
						<path
							d="m11.25 13.75-.085-.073a.75.75 0 0 0-.976.072l-.69.69v-6.69l-.007-.102a.75.75 0 0 0-.743-.648l-.102.007A.75.75 0 0 0 8 7.749v6.692l-.69-.692-.084-.072a.75.75 0 0 0-.976 1.133l1.969 1.97.084.073a.75.75 0 0 0 .977-.072l1.97-1.971.073-.084a.75.75 0 0 0-.072-.977ZM1.999 12c0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.524-4.477-10-10-10s-10 4.476-10 10Zm18.5 0a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0Zm-2.75 1.75-.084-.073a.75.75 0 0 0-.976.072l-.69.69v-6.69l-.007-.102a.75.75 0 0 0-.743-.648l-.102.007a.75.75 0 0 0-.648.743v6.691l-.69-.69-.083-.073a.75.75 0 0 0-.977 1.133l1.969 1.97.084.073a.75.75 0 0 0 .977-.072l1.97-1.971.073-.084a.75.75 0 0 0-.072-.977Z"
							fill="#212121"
						/>
					</svg>
					</button>
					<span class="granularity-text">{{ granularity }}</span>
					<button @click="drillDown" :disabled="granularity === 'milliseconds'" class="control-button" aria-label="Zoom in" title="Zoom in to a finer granularity">
					<!-- <svg width="24" height="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
						<path
						d="M11.25 13.75a.75.75 0 0 1 .072.976l-.072.084-1.971 1.97a.75.75 0 0 1-.977.073l-.084-.073-1.97-1.97a.75.75 0 0 1 .977-1.133l.085.072.69.691V7.75a.75.75 0 0 1 .647-.743l.102-.007a.75.75 0 0 1 .743.648l.007.102v6.69l.69-.69a.75.75 0 0 1 .976-.072l.085.072ZM1.999 12c0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.524-4.477-10-10-10s-10 4.476-10 10Zm15.666 1.677.085.072a.75.75 0 0 1 .072.977l-.072.084-1.971 1.97a.75.75 0 0 1-.977.073l-.084-.073-1.97-1.97a.75.75 0 0 1 .978-1.133l.084.072.69.691V7.75a.75.75 0 0 1 .647-.743l.102-.007a.75.75 0 0 1 .743.648l.007.102v6.69l.69-.69a.75.75 0 0 1 .976-.072Z"
						fill="currentColor"
						/>
					</svg> -->
						<svg width="24" height="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m11.25 13.75-.085-.073a.75.75 0 0 0-.976.072l-.69.69v-6.69l-.007-.102a.75.75 0 0 0-.743-.648l-.102.007A.75.75 0 0 0 8 7.749v6.692l-.69-.692-.084-.072a.75.75 0 0 0-.976 1.133l1.969 1.97.084.073a.75.75 0 0 0 .977-.072l1.97-1.971.073-.084a.75.75 0 0 0-.072-.977ZM1.999 12c0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.524-4.477-10-10-10s-10 4.476-10 10Zm18.5 0a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0Zm-2.75 1.75-.084-.073a.75.75 0 0 0-.976.072l-.69.69v-6.69l-.007-.102a.75.75 0 0 0-.743-.648l-.102.007a.75.75 0 0 0-.648.743v6.691l-.69-.69-.083-.073a.75.75 0 0 0-.977 1.133l1.969 1.97.084.073a.75.75 0 0 0 .977-.072l1.97-1.971.073-.084a.75.75 0 0 0-.072-.977Z" 
							fill="#212121"/>
						</svg>
					</button>
				</div>
            </div>
        </div>

        <!-- Gant Chart -->
        <div class="gantt-chart" ref="gantt">
            <!-- Gant Message -->
            <gantt-message v-if="message.show" :type="message.type" :message="message.text" @close="message.show = false"></gantt-message>

            <!-- Gant Header -->
            <div class="gantt-header">

                <!-- Gantt table section -->
                <div class="table-section" :style="{ width: widths.table + 'px' }">
                    <div class="table-cell" :class="{ sortable : !!field.sort }" :style="{ width: field.width + 'px' }" v-for="(field, slug) in dynamicFields" :key="slug" @click="handleSort(slug)">{{ field.label }}</div>
                </div>

                <!-- Gantt graph section -->
                <div class="graph-section" :style="{ width: widths.graph + 'px' }">
                    <div class="table-cell" :class="{ 'hidden-date' : !date.shown }" :style="{ width: widths.cell + 'px' }" v-for="(date, key) in dates" :key="key">
                        <span class="day">{{ date.date | moment(displayFormat.primary) }}</span>
                        <span class="month" v-if="displayFormat.secondary">{{ date.date | moment(displayFormat.secondary) }}</span>
                    </div>
                </div>

            </div>

            <!-- Gant body -->
            <div class="gantt-body">

                <!-- Gantt table row -->
                <div class="gantt-row" v-for="(item, key) in filteredSortedItems" :class="{ parent: item.isParent, child: item.isChild }" :key="`${item.id}-${granularity}-${key}`">
                    
                    <!-- Table section: start -->
                    <div class="table-section" :key="item.id" :style="{ width: widths.table + 'px'}">

                        <template v-if="localFields.toggle">
                            <div v-if="item.isParent" class="toggle" :style="{ width: localFields.toggle.width + 'px' }" @click="openItems.includes(item.id) ? openItems.splice(openItems.indexOf(item.id), 1) : openItems.push(item.id)">
                                <span :class=" { open: openItems.includes(item.id), close: !openItems.includes(item.id) }"></span>
                            </div>
                            <div v-else :style="{ width: localFields.toggle.width + 'px' }"></div>
                        </template>

                        <div class="table-group">
                            <template v-for="(field, slug) in getValidFields(item)">
                                <gantt-user v-if="localFields[field].component === 'gantt-user'" class="table-cell" v-model="item[field]" :style="{ 'padding-left': (field === longest_cell.slug && item.isChild) ? indent + 'px' : ''  }" :key="`${item.id}-${slug}-${granularity}`" :width="localFields[field].width" :user="user" :editable="canEdit && !item.isParent"></gantt-user>
                                <gantt-text v-if="localFields[field].component === 'gantt-text'" :class="['table-cell', { 'non-editable': !canEdit }]" v-model="item[field]" :style="{ 'padding-left': (field === longest_cell.slug && item.isChild) ? indent + 'px' : ''  }" :key="`${item.id}-${slug}-${granularity}`" :width="localFields[field].width" :event-type="item.event_type" @update="cellUpdated(localFields[field].callback, item)" :editable="canEdit"></gantt-text>
                                <gantt-date v-if="localFields[field].component === 'gantt-date'" class="table-cell" v-model="item[field]" :style="{ 'padding-left': (field === longest_cell.slug && item.isChild) ? indent + 'px' : ''  }" :key="`${item.id}-${slug}-${granularity}`" :width="localFields[field].width" :minDate="item[localFields[field].minDate]" @update="cellUpdated(localFields[field].callback, item)" :editable="canEdit && !item.isParent"></gantt-date>
                                <gantt-number v-if="localFields[field].component === 'gantt-number'" class="table-cell" v-model="item[field]" :style="{ 'padding-left': (field === longest_cell.slug && item.isChild) ? indent + 'px' : ''  }" :key="`${item.id}-${slug}-${granularity}`" :width="localFields[field].width" :min="localFields[field].min" :max="localFields[field].max" :suffix="localFields[field].suffix" @update="cellUpdated(localFields[field].callback, item)" :editable="canEdit && !item.isParent"></gantt-number>
                            </template>
                        </div>

                    </div>
                     <!-- Table section: end -->

                    <!-- Graph section:start -->
                    <div class="graph-section" :style="{ width: widths.graph + 'px' }">
                        <gantt-graph :item="item" :dates="dates" :cell_width="widths.cell" :user="user" :open="!item.isParent || openItems.includes(item.id)" :editable="canEdit" :granularity="granularity" @date-updated="dateUpdated" @open="openItems.push(item.id)"></gantt-graph>
                    </div>
                    <!-- Graph section:end -->

                </div>

            </div>

            <!-- Gantt body: start -->
            <div v-if="false" class="gantt-body" style="margin-top: 50px;">
                <div class="gantt-table" :style="{ width: widths.table + 'px' }"></div>
                <div class="gantt-graph-panel" :style="{ width: widths.graph + 'px' }">
                    <div class="gantt-row" v-for="(item, key) in filteredSortedItems" :key="key">
                        <div class="marker" :class="{ parent : item.isParent }" :style="{ width: (widths.cell * item.duration) + 'px', left: computedOffset(item) }"></div>
                    </div>
                </div>
            </div>
            <!-- Gantt body: end -->

        </div>
    </div>
</template>

<script>
import Vue from 'vue'

import GanttText from './gantt-text'
import GanttDate from './gantt-date'
import GanttNumber from './gantt-number'
import GanttUser from './gantt-user'
import GanttMessage from './gantt-message'
import GanttGraph from './gantt-graph'

export default {
	name: 'Gantt',
	components: { GanttText, GanttDate, GanttNumber, GanttUser, GanttMessage, GanttGraph },
	props: {
		/**
		 * String that shows the gantt title
		 * @default ''
		 * @type {String}
		 */
		title: {
			type: String,
			default: ''
		},

		/**
		 * Array that lists all items of the gantt chart
		 * @default '[]'
		 * @type {Array}
		 */
		items: {
			type: Array,
			default: () => {
				return []
			}
		},

		/**
		 * Object that lists all header fields of the gantt chart
		 * @default '{}'
		 * @type {Object}
		 */
		fields: {
			type: Object,
			default: () => {
				return {
					start_date: {
						label: 'Start',
						component: 'gantt-date',
						width: 70,
						placeholder: 'Start',
						sort: 'date'
					},
					end_date: {
						label: 'End',
						component: 'gantt-date',
						width: 70,
						placeholder: 'End',
						sort: 'date'
					},
					duration: {
						label: 'Days',
						component: 'gantt-number',
						width: 50,
						placeholder: '0'
					}
				}
			}
		},

		/**
		 * Number to indicate the nesting levels of a task
		 * @default '2'
		 * @type {Number}
		 */
		levels: {
			type: Number,
			default: 2
		},

		/**
		 * String to indicate the key of nested items
		 * @default '2'
		 * @type {String}
		 */
		levelKey: {
			type: String,
			default: 'items'
		},

		/**
		 * String, Number to indicate the amount of dates shown in the chart
		 * @default '12'
		 * @type {String, Number}
		 */
		dateLimit: {
			type: [String, Number],
			default: 'auto'
		},

		/**
		 * String to define the start date of the Gantt chart
		 * @default 'today'
		 * @type {String}
		 */
		startDate: {
			type: String,
			default: () => {
				return Vue.moment()
					.subtract(2, 'd')
					.format('YYYY-MM-DD HH:mm:ss.SSS')
			}
		},

		/**
		 * String to define the start date of the Gantt chart
		 * @default 'today'
		 * @type {String}
		 */
		endDate: {
			type: String,
			default: () => {
				return Vue.moment()
					.add(5, 'd')
					.format('YYYY-MM-DD HH:mm:ss.SSS')
			}
		},

		/**
		 * Boolean to define if new rows can be added
		 * @default 'true'
		 * @type {Boolean}
		 */
		canEdit: {
			type: Boolean,
			default: false
		},

		/**
		 * Object to reflect the user object
		 * Or boolean to indicate no user object
		 * @default 'true | {}'
		 * @type {Boolean, Object}
		 */
		user: {
			type: [Boolean, Object],
			default: () => {
				return {
					id: 'id',
					image: 'src'
				}
			}
		}
	},
	data() {
		return {
			widths: {
				gantt: 0,
				table: 0,
				graphh: 0,
				cell: 0
			},
			indent: 20,
			longest_cell: { width: 0, slug: '' },
			dateFormat: 'YYYY-MM-DD HH:mm:ss.SSS',
			localFirstDate: '',
			localItems: this.compileItems(this.items),
			localFields: this.fields,
			localStartDate: this.startDate,
			localEndDate: this.endDate,
			localDateLimit: this.dateLimit,
			// requiredFields: ['start_date', 'end_date', 'duration'],
			requiredFields: ['start_date', 'duration'],
			sortBy: false,
			message: {
				show: false,
				type: '',
				text: ''
			},
			openItems: [],
			granularity: 'days',
			granularityLevels: ['days', 'hours', 'minutes', 'seconds', 'milliseconds'],
			// timeStartDate: this.startDate,
			timeStartDate: this.earliest_parent_date,
		}
	},
	mounted() {
		let self = this

		this.localFields = { toggle: { label: '', width: 20 }, ...this.fields }

		// Calculate the table by
		// sumizing the individual columns
		let fields = []
		Object.keys(this.localFields).forEach(field_key => {
			let field_width = this.localFields[field_key].width
			this.widths.table += field_width
			fields.push(field_key)

			// Add mandatory calbacks
			if (field_key === 'start_date') this.localFields[field_key].callback = 'startdateUpdated'
			if (field_key === 'end_date') this.localFields[field_key].callback = 'enddateUpdated'
			// if (field_key === 'end_date') this.localFields[field_key].minDate = 'start_date'
			if (field_key === 'duration') this.localFields[field_key].callback = 'durationUpdated'

			// Find longest table cell
			if (this.longest_cell.width < field_width) this.longest_cell = { width: field_width, slug: field_key }
		})

		// Check if all the required fields are provided
		// provided in the gantt props
		let valid_fields = this.requiredFields.every(field => fields.includes(field))
		if (!valid_fields) this.handleInvalidFields()

		// Set all the specific Gantt widths
		// Gantt, Graphs, Cells
		this.calculateWidths()
		window.onresize = function(event) {
			self.calculateWidths()
		}

		// Init draggable markers
		this.$nextTick().then(() => {
			self.initDragable()
		})
	},
	methods: {
		/*
        | Compile the list of items
        | This will flatten the multidimentional array
        | to a more feasable array.
        */
		compileItems(items) {
			let result = []
			let earliest_parent_date = null
			// Loop over all the given items
			items.forEach(item => {
				// Check if the item has a key
				// that indicitats if it has children
				let has_level = Object.prototype.hasOwnProperty.call(item, this.levelKey)

				// If we have children
				// Mark the item as a parent item
				if (has_level && item[this.levelKey].length > 0) {
					item.isParent = true
					// Capture earliest parent start time
					if (!earliest_parent_date || new Date(item.start_date) < new Date(earliest_parent_date)) {
						earliest_parent_date = item.start_date	
					}
					
					let k = result.push(item)
					let children = item[this.levelKey].forEach(child => {
						child.isChild = true
						child.isParent = false
						child.parentId = item.id
						result.push(child)
					})
					delete result[k][this.levelKey]
				} else {
					item.isParent = false
					result.push(item)
				}
			})

			// Set timeStartDate using earliest parent's time part
			if (earliest_parent_date) {
				this.earliest_parent_date = earliest_parent_date
				const earliestTime = this.$moment(earliest_parent_date).format('HH:mm:ss.SSS')
				const currentDate = this.$moment(this.localStartDate).format('YYYY-MM-DD')
				// this.timeStartDate = `${currentDate} ${earliestTime}`
				this.timeStartDate = earliest_parent_date
			}
            
			return result
		},

		/*
        | Calculates the odifferent widths
        | chart, cell, gantt
        */
		calculateWidths() {
			this.widths.gantt = this.$refs.gantt.offsetWidth
			this.widths.graph = this.widths.gantt - this.widths.table
			if (this.dateLimit !== 'auto') this.widths.cell = this.widths.graph / this.localDateLimit
			else this.calculateOptimalDateLimit()
		},

		/*
        | Calculates the optional date limit
        */
		calculateOptimalDateLimit() {
			this.localDateLimit = 15
			this.widths.cell = this.widths.graph / this.localDateLimit
		},

		/*
        | Set the start date 1 day earlier
        */
		prev() {
			this.localStartDate = this.$moment(this.localStartDate)
				.subtract(1, 'd')
				.format(this.dateFormat)
		},

		/*
        | Set the start date 1 day in the future
        */
		next() {
			this.localStartDate = this.$moment(this.localStartDate)
				.add(1, 'd')
				.format(this.dateFormat)
		},

		/*
        | Handle function when not all
        | required fields are provided
        */
		handleInvalidFields() {
			this.message.show = true
			this.message.type = 'missing_required_fields'
			this.message.text = ''
		},

		/*
        | Handle function when a
        | cell has been updated
        */
		cellUpdated(callback, cell) {
			if (callback) this[callback](cell)

			this.$emit('update', cell)
		},

		/*
        | start_date updated callback
        | When updating the start_date also update end date based on duration
        */
		startdateUpdated(cell) {
			if (!cell.ignoreCallback) cell.ignoreCallback = {}
			if (cell.ignoreCallback.start_date) {
				cell.ignoreCallback.start_date = false
				return
			}

			cell.end_date = this.$moment(cell.start_date, this.dateFormat)
				.add(cell.duration, 'd')
				.format(this.dateFormat)

			if (cell.isChild && !cell.recursive) {
				// Get the parent item of the child
				let parent_item = this.localItems.find(item => item.id === parseInt(cell.parentId))
				// Get all the parents children
				let children = this.localItems.filter(item => item.parentId === parseInt(cell.parentId))
				let start_date = children[0].start_date
				let end_date = children[0].end_date

				// Calculate first and last date
				children.forEach(child => {
					start_date = new Date(child.start_date) < new Date(start_date) ? child.start_date : start_date
					end_date = new Date(child.end_date) > new Date(end_date) ? child.end_date : end_date
				})
				let duration = this.$moment(end_date, this.dateFormat).diff(this.$moment(start_date, this.dateFormat), 'd')

				// Ignore the default callback
				// We want to set the properties bottom up
				// not top down
				if (!parent_item.ignoreCallback) parent_item.ignoreCallback = {}
				parent_item.ignoreCallback.start_date = true
				parent_item.ignoreCallback.end_date = true
				parent_item.ignoreCallback.duration = true

				// Set the properties
				parent_item.start_date = start_date
				parent_item.end_date = end_date
				parent_item.duration = duration
			}
		},

		/*
        | end_date updated callback
        */
		enddateUpdated(cell) {
			if (!cell.ignoreCallback) cell.ignoreCallback = {}
			if (cell.ignoreCallback.end_date) {
				cell.ignoreCallback.end_date = false
				return
			}

			let date_diff = this.$moment(cell.end_date, this.dateFormat).diff(this.$moment(cell.start_date, this.dateFormat), 'd')
			if (date_diff > 0) cell.duration = date_diff

			cell.ignoreCallback.duration = true
		},

		/*
        | duration updated callback
        */
		durationUpdated(cell) {
			if (!cell.ignoreCallback) cell.ignoreCallback = {}
			if (cell.ignoreCallback.duration) {
				cell.ignoreCallback.duration = false
				return
			}
			console.log('-- callback: duration updated')

			let end_date = this.$moment(cell.start_date, this.dateFormat).add(cell.duration - 1, 'd')
			cell.end_date = end_date.format(this.dateFormat)

			if (cell.isChild) {
				console.log('child is updated')
				// Get the parent item of the child
				let parent_item = this.localItems.find(item => item.id === parseInt(cell.parentId))
				// Get all the parents children
				let children = this.localItems.filter(item => item.parentId === parseInt(cell.parentId))
				let start_date = cell.start_date
				let end_date = cell.end_date

				// Calculate first and last date
				children.forEach(child => {
					start_date = new Date(child.start_date) < new Date(start_date) ? child.start_date : start_date
					end_date = new Date(child.end_date) > new Date(end_date) ? child.end_date : end_date
				})
				let duration = this.$moment(end_date, this.dateFormat).diff(this.$moment(start_date, this.dateFormat), 'd') + 1

				if (!parent_item.ignoreCallback) parent_item.ignoreCallback = {}
				parent_item.ignoreCallback.end_date = true

				// Set the properties
				parent_item.duration = duration
				parent_item.end_date = end_date
			}

			cell.ignoreCallback.end_date = true
		},

		/*
        | Handle when a new chart date has updated
        */
		dateUpdated(itemId, newDate) {
			let item = this.localItems.find(item => item.id === parseInt(itemId))
			item.start_date = newDate
		},

		/*
        | Handle when a marker is dragged
        */
		initDragable() {
			let graph = document.querySelector('.graph-section')
			let cell_limit = this.dates.length

			// Handle mouse up event on
			// a marker element
			document.documentElement.onmouseup = e => {
				e.preventDefault()
				if (!window.markers || window.markers.length === 0) return false

				window.markers.forEach(marker => {
					let drop_date = this.dates[marker.lastCell - 1].date
					let row_id = marker.dataset.rowId
					let item = this.localItems.find(item => item.id === parseInt(row_id))
					item.recursive = marker.recursive

					marker.classList.remove('selected')
					if (item) item.start_date = drop_date
				})
				window.markers = []
			}

			// Handle mouse move event on
			// a marker element
			let match_cell = 0
			let chart_offset = graph.offsetLeft
			document.documentElement.onmousemove = e => {
				e.preventDefault()
				if (!window.markers || window.markers.length === 0) return false

				window.markers.forEach(marker => {
					let l = +window.getComputedStyle(marker)['left'].slice(0, -2) || 0

					for (let i = 1; i < cell_limit + 1; i++) {
						if (Math.floor((i * this.widths.cell) / (e.clientX + marker.offset - chart_offset)) !== 0) {
							match_cell = i
							break
						}
					}

					if (marker.lastCell !== match_cell) {
						marker.style.left = (match_cell - 1) * this.widths.cell + 'px'
						marker.lastCell = match_cell
					}
				})
			}
        },
        
        computedOffset(item){
            const baseDate = ['hours', 'minutes', 'seconds', 'milliseconds'].includes(this.granularity) ? this.timeStartDate : this.localStartDate
            const unit = this.granularity === 'milliseconds' ? 'millisecond' : this.granularity.slice(0, -1)
            const intervals = {
                days: 1,
                hours: 1,
                minutes: 4,
                seconds: 4,
                milliseconds: 67
            }
            const interval = intervals[this.granularity] || 1
            
            let offset = this.$moment(baseDate, this.dateFormat).diff(this.$moment(item.start_date, this.dateFormat), unit) / interval
            let width = Math.abs(offset * this.widths.cell)

            return width + 'px'
        },

        /*
        | Get valid fields for an item
        | Returns only fields that exist in localFields
        */
        getValidFields(item) {
            return Object.keys(item).filter(field => Object.prototype.hasOwnProperty.call(this.localFields, field))
        },

        /*
        | Handle sorting by field
        */
        handleSort(field) {
            this.sortBy = field
            this.$nextTick(() => {
                this.sortBy = false
            })
        },

        /*
        | Drill down to next granularity level
        */
        drillDown() {
            const currentIndex = this.granularityLevels.indexOf(this.granularity)
            if (currentIndex < this.granularityLevels.length - 1) {
                this.granularity = this.granularityLevels[currentIndex + 1]
            }
        },

        /*
        | Drill up to previous granularity level
        */
        drillUp() {
            const currentIndex = this.granularityLevels.indexOf(this.granularity)
            if (currentIndex > 0) {
                this.granularity = this.granularityLevels[currentIndex - 1]
            }
        },
		/*
		| Navigate backward in time by current granularity
		*/
		prevTime() {
			const unit = this.granularity === 'milliseconds' ? 'millisecond' : this.granularity.slice(0, -1)
			this.timeStartDate = this.$moment(this.timeStartDate, 'YYYY-MM-DD HH:mm:ss.SSS').subtract(1, unit).format('YYYY-MM-DD HH:mm:ss.SSS')
		},

		/*
		| Navigate forward in time by current granularity
		*/
		nextTime() {
			const unit = this.granularity === 'milliseconds' ? 'millisecond' : this.granularity.slice(0, -1)
			this.timeStartDate = this.$moment(this.timeStartDate, 'YYYY-MM-DD HH:mm:ss.SSS').add(1, unit).format('YYYY-MM-DD HH:mm:ss.SSS')
		},
		/*
		| Navigate backward in time by current granularity
		*/
		prevDoubleTime() {
			const unit = this.granularity === 'milliseconds' ? 'millisecond' : this.granularity.slice(0, -1)
			this.timeStartDate = this.$moment(this.timeStartDate, 'YYYY-MM-DD HH:mm:ss.SSS').subtract(3, unit).format('YYYY-MM-DD HH:mm:ss.SSS')
		},

		/*
		| Navigate forward in time by current granularity
		*/
		nextDoubleTime() {
			const unit = this.granularity === 'milliseconds' ? 'millisecond' : this.granularity.slice(0, -1)
			this.timeStartDate = this.$moment(this.timeStartDate, 'YYYY-MM-DD HH:mm:ss.SSS').add(3, unit).format('YYYY-MM-DD HH:mm:ss.SSS')
		},

		/*
		| Navigate to a specific moment from dropdown
		*/
		navigateToMoment(startDate) {
			if (!startDate) return
			
			// For time-based granularities, update timeStartDate
			if (['hours', 'minutes', 'seconds', 'milliseconds'].includes(this.granularity)) {
				this.timeStartDate = this.$moment(startDate, this.dateFormat).subtract(2, this.granularity.slice(0, -1)).format(this.dateFormat)
			} else {
				// For days granularity, update localStartDate
				this.localStartDate = this.$moment(startDate, this.dateFormat).subtract(2, 'd').format(this.dateFormat)
			}
		}
	},
	computed: {
		/*
        | Generate a list of dates based on current granularity
        */
		dates() {
			let dates = []
			const baseDate = ['hours', 'minutes', 'seconds', 'milliseconds'].includes(this.granularity) ? this.timeStartDate : this.localStartDate
			const startMoment = this.$moment(baseDate, this.dateFormat)
			const unit = this.granularity === 'milliseconds' ? 'millisecond' : this.granularity.slice(0, -1)
			const intervals = {
				days: 1,
				hours: 1,
				minutes: 4,
				seconds: 4,
				milliseconds: 67
			}
			const interval = intervals[this.granularity] || 1

			for (let index = 0; index < this.localDateLimit; index++) {
				dates.push({
					shown: true,
					date: startMoment.clone()
						.add(index * interval, unit)
						.format(this.dateFormat)
				})
			}

			return dates
		},

		/*
        | Generate a list of sorted
        | items to show in teh gantt chart
        */
		localSortedItems() {
			let items = [...this.localItems]

			if (this.sortBy) {
				let sort_type = this.localFields[this.sortBy].sort
				if (sort_type === 'date') {
					items.sort((a, b) => {
						return new Date(a[this.sortBy]) - new Date(b[this.sortBy])
					})
				}
			}

			return items
		},

		/*
        | Generate a filtered list of sorted items
        | based on parent/child visibility rules
        */
		filteredSortedItems() {
			return this.itemsWithConvertedDuration.filter(item => 
				!item.isChild || (item.isChild && this.openItems.includes(item.parentId))
			)
		},

		/*
        | Convert durations based on current granularity
        */
		itemsWithConvertedDuration() {
			// Explicitly depend on granularity for reactivity
			const currentGranularity = this.granularity
			return this.localSortedItems.map(item => {
				const conversions = {
					days: item.duration / (1000 * 60 * 60 * 24),
					hours: item.duration / (1000 * 60 * 60),
					minutes: item.duration / (1000 * 60),
					seconds: item.duration / 1000,
					milliseconds: item.duration
				}
				const converted = conversions[currentGranularity] || conversions.days
				const convertedDuration = converted < 1 && converted > 0 
					? Math.max(0.01, Math.round(converted * 100) / 100)
					: Math.round(converted)
				
				// console.log(`Converting ${item.duration}ms to ${currentGranularity}: ${convertedDuration}`)
				
				return {
					...item,
					duration: convertedDuration
				}
			})
		},

		/*
        | Get display format based on granularity
        */
		displayFormat() {
			const formats = {
				days: { primary: 'D', secondary: 'MMM' },
				hours: { primary: 'HH:mm', secondary: 'DD MMM' },
				minutes: { primary: 'mm', secondary: '' },
				seconds: { primary: 'ss', secondary: '' },
				milliseconds: { primary: 'SSS', secondary: '' }
			}
			return formats[this.granularity] || formats.days
		},

		/*
        | Get dynamic field labels based on granularity
        */
		dynamicFields() {
			const fields = { ...this.localFields }
			
			// if (fields.start_date) {
			// 	fields.start_date.label = this.granularity === 'days' ? 'Start' : 'DateTime'
			// }
			// if (fields.end_date) {
			// 	fields.end_date.label = this.granularity === 'days' ? 'End' : 'DateTime'
			// }
			if (fields.duration) {
				const labels = {
					days: 'Days',
					hours: 'Hrs',
					minutes: 'Mins',
					seconds: 'Secs',
					milliseconds: 'Ms'
				}
				fields.duration.label = labels[this.granularity] || 'Days'
			}
			
			return fields
		},

		/*
        | Get key moments for dropdown navigation
        */
		keyMoments() {
			return this.localItems
				.filter(item => item.id && item.summary && item.start_date)
				.sort((a, b) => new Date(a.start_date) - new Date(b.start_date))
		}
	},
	watch: {
		/*
        | Get the end_date based on the 
        | generated dates array.
        */
		dates: function() {
			this.localEndDate = this.dates[this.dates.length - 1].date
		},

		/*
        | Recalculate date limits when granularity changes
        */
		granularity: function() {
			this.calculateOptimalDateLimit()
		},

		/*
        | Debug watcher for localStartDate changes
        */
		localStartDate: function(newVal, oldVal) {
			// console.log('localStartDate watcher - old:', oldVal, 'new:', newVal)
			// console.trace('localStartDate changed by:')

			// Keep timeStartDate anchored to localStartDate date only
			const newDate = this.$moment(newVal).format('YYYY-MM-DD')
			const currentTime = this.$moment(this.timeStartDate).format('HH:mm:ss.SSS')
			this.timeStartDate = `${newDate} ${currentTime}`
		},

		/*
        | Sync localStartDate when timeStartDate date part changes
        */
		timeStartDate: function(newVal, oldVal) {
			const newDate = this.$moment(newVal).format('YYYY-MM-DD')
			const localDate = this.$moment(this.localStartDate).format('YYYY-MM-DD')
			if (newDate !== localDate) {
				const currentTime = this.$moment(this.localStartDate).format('HH:mm:ss.SSS')
				// currentTime
				this.localStartDate = `${newDate} ${currentTime}`
			}
		}
	}
}
</script>